<template>
  <v-container v-focus-section>

    <h1 class="mt-7">{{ tag.name }}</h1>

    <v-row class="mt-7">
      <v-col v-for="(show,i) in shows" 
             :key="i"
             cols="3">
        <ShowCard :show="show"/>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import API from '@/api'

import slugMixin from '@/mixins/slug'
import utility from '@/mixins/utility'

import ShowCard from '@/components/show/Card'

export default {
  
  name: 'Tag',

  mixins: [ slugMixin, utility ],

  components: {
    ShowCard
  },

  data: () => ({
     tag: {}
  }),

  computed: {
    shows()
    {
      return this.tag.shows
    }
  },

  methods:
  {
    load()
    {
      API.tags.one(this.slug)
              .then((res)=>{
                this.tag = this.mapModel(res.data.data, 'tag')
              })
    }
  },

  mounted()
  {
    this.load()
  }

}
</script>
